export default __webpack_public_path__ + "static/media/waterfloor2.ba87aea6.png";